<template>
  <modal ref="modal">
    <modal-body :message="message" />
    <modal-footer>
      <update-button @click="doUpdate" />
      <cancel-button data-coreui-dismiss="modal" />
    </modal-footer>
  </modal>
</template>

<script>
import Modal from "@/views/atoms/Modal";
import ModalBody from "@/views/atoms/ModalBody";
import ModalFooter from "@/views/atoms/ModalFooter";
import UpdateButton from '@/views/molecules/buttons/UpdateButton';
import CancelButton from '@/views/molecules/buttons/CancelButton';

export default {
  name: "EditConfirmModal",
  emits: ['update'],
  props: {
    message: {
      type: String,
      default: "更新してよろしいですか？",
    },
  },
  components: {
    Modal,
    ModalBody,
    ModalFooter,
    UpdateButton,
    CancelButton,
  },
  methods: {
    show() {
      this.$refs.modal.show();
    },
    doUpdate() {
      this.$refs.modal.hide();
      this.$emit('update');
    },
  },
}
</script>
